import styled from "styled-components";

export const Styles = styled.div`
  .flex-row {
    display: flex;
  }
  
  .flex-col {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .tag-cont {
    margin-top: var(--size);
    padding: 0px;
  }

  .ant-page-header {
    padding: 8px 8px 8px var(--size);
    
    .ant-btn {
      display: flex;
      span[role="img"] {
        font-size: 18px;
      }
    }
  }

  .ant-space {
    width: 100%;
    div:nth-of-type(1) {
      width: 100%;
    }
  }
`;
